import React, { useEffect } from 'react'
import DropdownSection from './components/DropdownSection'
import { isJaguar } from '@/utility/UserUtils'
import { Formik } from 'formik'
import { renderTextField, renderSwitchField, renderTextAreaField,renderMoneyField, renderCurrencyField, renderSelectFieldFilterable, renderButton, renderCancelButton, renderCreateButton, renderSubmitButton, renderDeleteButton, renderCheckField, renderCheckFieldDisabled, renderRadioField} from "@/shared/FormUtils";
import { Stack, Button, Switch, Link } from '@mui/material';
import { fetchAPI } from '@/utility/NetworkUtils'
import CustomFieldModal from './components/CustomFieldModal'
import ItemLogModal from './ItemLogModal'
import AttachmentModal from './components/AttachmentModal'
import ReceivingListTrackingNumberForm from "./ReceivingListTrackingNumberForm"
import { InputAdornment } from '@mui/material';
import { type } from '@linways/table-to-excel';
import ItemImageModal from './components/ItemImageModal';
import {ArrowUpward, ArrowDownward} from '@mui/icons-material';
import Loading from '@/shared/Loading';
import { object, string, number } from 'yup';

import ItemInventoryModal from './components/ItemInventoryModal';
import InventoryChits from '../components/InventoryChits';
import ItemHoldFormRevised from './ItemHoldFormRevised';
const ItemFormRevised = (props) => {
  const { user, item, renter } = props
  const [ renters, setRenters ] = React.useState(renter ? [renter] : [])
  const [ categories, setCategories ] = React.useState([])
  const [ inventoryLogModalOpen, setInventoryLogModalOpen ] = React.useState(false)
  const [ attachments, setAttachments ] = React.useState(item.item_attachments)
  const [ attachmentModalOpen, setAttachmentModalOpen ] = React.useState(false)
  const [ attachmentModalId, setAttachmentModalId ] = React.useState(null)

  const [ itemImages, setItemImages ] = React.useState(item.item_images)
  const [ itemImageModalOpen, setItemImageModalOpen ] = React.useState(false)
  const [ itemImageModalId, setItemImageModalId ] = React.useState(null)
  const [ inventoryCount, setInventoryCount ] = React.useState(null)
  
  const [ inventoryModalOpen, setInventoryModalOpen ] = React.useState(false)
  const [ attemptedSubmit, setAttemptedSubmit ] = React.useState(false)
  useEffect(() => {
    fetchRenters()
    fetchCategories()
    fetchInventoryCount()
  }, [])

 const fetchInventoryCount = async () => {
    setInventoryCount(null)
    fetchAPI(`/webapi/items/${item.id}/inventory_count`, (json)=> {
      if (!json.errors) {
        setInventoryCount(json)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
 }

  const fetchAttachments = async () => {
    fetchAPI(`/webapi/items/${item.id}`, (json)=> {
      if (!json.errors) {
        setAttachments(json?.item?.item_attachments)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }

  const fetchItemImages = async () => {
    fetchAPI(`/webapi/items/${item.id}`, (json)=> {
      if (!json.errors) {
        setItemImages(json?.item?.item_images)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }

  const fetchCategories = async () => { 
    fetchAPI(`/webapi/categories/all`, (json)=> {
      if (!json.errors) {
        setCategories(json.categories)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }

  const fetchRenters = async () => {
    fetchAPI(`/webapi/renters`, (json)=> {
      if (!json.errors) {
        setRenters(json.renters)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }
  
  const getInitialValues = () => {
    if(item.renter_id == null && renter){
      item.renter_id = renter.id
    }
    let values = {
      item,
      add_to_receiving_list: true,
      receiving_item: {
        item_id: item.id,
        notes: "",
        ordered: 0, //This will update on submit
      },
      receiving_item_tracking_numbers: [],
      delete_form_merge_with_existing_item: false,
      quantity: null,
      add_to_event: false,
      delete_event:[],
      item_hold: {
        event_id: null,
        item_id: item.id,
        total_count: 1,
        order_not_finalized: true,
        not_returning: false,
        direct_to_site: false,
        shipping_address_id: null,
        location: null,
        recipient: null,
        notes: "",
        dispose_after_event: false
      }
    }
    const currency_fields = [
      "rental_cost",
      "sale_cost",
      "purchase_cost"
    ]
    currency_fields.forEach((field) => {
      if(values.item[field] != null) {
        values.item[field] = parseFloat(values.item[field]||"").toFixed(2)
      }
    })

    if(typeof values?.item?.custom_fields == "string") {
      values.item.custom_fields = JSON.parse(values?.item?.custom_fields).fields||[]
    }
    return values
  }

  const submitForm = (values, formikProps) => {
    let newValues = JSON.parse(JSON.stringify(values))
    formikProps.setSubmitting(true)
    values.receiving_item.ordered = values.quantity
    values.item_hold.total_count = values.quantity
    fetchAPI(`/webapi/items/${item.id}`, (json)=> {
      formikProps.setSubmitting(false)
      if (!json.errors) {
        window.location = `/items/${item.id}`
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {
      method: "PATCH",
      body: values
    });
  }

  const isNewItem = () => {
    return !!item.draft;  
  }

  const getCategoryOptions = (formikProps) => {
    const { item } = formikProps.values
    return categories.filter(x=> x.renter_id == item.renter_id).map((category) => {
      return {
        label: category.group_name + " - " + category.name,
        value: category.id
      }
    }).sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))
  }

  const renderItemDetails = (formikProps) => {
    return (
      <div>
        <Stack spacing={2} direction="column">
          {renderTextField( "Item Name", "item[name]", {required: true})}
          <div className='flex align-middle items-center'>
            {!renter && (
              <div className="w-1/2 inline-block pr-2">
                {renderSelectFieldFilterable(
                  "Owner",
                  "item[renter_id]",
                  [{label: "Jaguar Design Studio", value: null}].concat(renters.map((renter) => {
                    return {
                      label: renter.name,
                      value: renter.id
                    }
                  }),
                ),{required: true})}
              </div>
            )}

            <div className="w-1/2 inline-block" style={renter ? {marginTop: "-20px"} : {} }>
              <label>{" "}</label>
              {isJaguar(user) && renderSwitchField("Turn on Public View", "item[public]",{isClearable: false,disableClearable: true})}
            </div>
          </div>
          <Stack direction="row" spacing={2}>
            {renderSelectFieldFilterable( "Category", "item[category_id]", getCategoryOptions(formikProps), {required: true})}
          </Stack>
          {renderEditingInventoryCounts(formikProps)}
          {item.draft && (
            <Stack direction="row" spacing={2}>

                <div className="w-1/2">
                  {renderTextField( "Quantity", "quantity", {
                    required: true,
                    
                    fieldProperties: {
                      type: "number",
                      step: 1,
                      InputProps:{
                          min: 0,
                          step: '1', // Ensures a step of 1 for integer increments
                          pattern: '[0-9]*', // Hints to virtual keyboards for numeric input
                          inputMode: 'numeric' // Further hints for mobile keyboards
                      }
                    }
                  })}
                </div>
            </Stack>
          )}
        </Stack>
      </div>
    )
  }

  const renderEditingInventoryCounts = (formikProps) => {
    if(!item.draft) {
      if(inventoryCount == null) {
        return (
          <div>
           <Loading/>
          </div>
        )
      } else if (inventoryCount?.error) {
        return (
          <div>
            <b>An Error Occured Loading Inventory:</b>
            {inventoryCount.error}
          </div>
        )
      } else {
        return (
          <div className="item-form-inventory-chit-container">
            <InventoryChits 
              item={item}
              inventoryCount={inventoryCount}
            />
            {renderButton(isJaguar(user) ? "Edit Inventory" : "Add to Inventory", onEditInventory, {color:"green", className:"self-right max-h-[40px] ml-auto"})}
          </div>
        )
      }
    }
  }

  const onEditInventory = () => {
    setInventoryModalOpen(true)
  }

  const renderItemSpecifications = (formikProps) => {
    const fieldProperties = {
      type: "number",
      InputProps: {
        endAdornment: <InputAdornment position="end">{
          formikProps.values.item.size_type ? "ft." : "in."
        }</InputAdornment>,
        inputProps: {
          min: 0
        }
      },
    }
    return (
      <div>
        <Stack spacing={2} direction="column">
          {renderTextAreaField( "Description (optional)", "item[description]", {
            multiline: true,
            rows: 5
          })}
          <Stack direction="row" spacing={2}>
            {renderTextField( "Color", "item[color]", {})}
            {renderTextField( `Brand or Manufacturer ${!renter ? "(Internal)" : ""}`, "item[brand]", {})}
          </Stack>
          <Stack direction="row" spacing={2}>
            {renderTextField( "Item Width", "item[product_width]", {type: "number",
              fieldProperties
            })}
            {renderTextField( "Item Height", "item[product_height]", {type: "number", fieldProperties})}
            {renderTextField( "Item Depth", "item[product_length]", {type: "number", fieldProperties})}
            <div className="sg-mgmt-form-input-container">
              <label>In. or Ft.</label>

              {renderSwitchField( `${formikProps.values.item.size_type ? "ft.":"in."}`, "item[size_type]", {isClearable: false})}
            </div>
          </Stack>
          <Stack direction="row" spacing={2}>

            {renderSelectFieldFilterable("Apparel Gender", "item[apparel_gender]", 
              [{label: "Unisex", value: "Unisex"}, {label: "Men", value: "Men"}, {label: "Women", value: "Women"}]
            )}
            {renderSelectFieldFilterable("Apparel Size", "item[apparel_size]", 
              ["XS", "SM","MD","LG","XL","XXL","XXXL", "Other"].map((size) => {
                return {
                  label: size,
                  value: size
                }
              })
            )}
            {renderTextField("Spacing2","spacing",{
              formatClasses:"invisible",
              style: {
                visibility: "hidden"
              }
            })}
          </Stack>
          {renderCustomFields(formikProps)}
          <div>
          <Link
            component={"button"}
            onClick={()=>{
              setEditingCustomFieldIndex(null)
              setCustomFieldModalOpen(true)
            }}
          >
            + Add Custom Field
          </Link>
          <CustomFieldModal
            open={customFieldModalOpen}
            index={editingCustomFieldIndex}
            onClose={() => {setCustomFieldModalOpen(false)}}
            formikProps={formikProps}
          />
          </div>
        </Stack>
      </div>
    )
  }

  const [ customFieldModalOpen, setCustomFieldModalOpen ] = React.useState(false)
  const [ editingCustomFieldIndex, setEditingCustomFieldIndex ] = React.useState(null)

  const renderCustomFields = (formikProps) => {
    if(typeof formikProps?.values?.item?.custom_fields == "string") {
      return
    }
    const currentCustomFields = ((formikProps?.values?.item?.custom_fields)||[])

    return currentCustomFields.map((field, index) => {
      return (
        <div className="w-2/3 pr-[5px]">
          {renderTextField(field.name, `item[custom_fields][${index}].value`)}
          <div className="text-blue-600 text-sm font-normal font-['Roboto']">
            <a href="#" onClick={(e) => {
              e.preventDefault()
              setEditingCustomFieldIndex(index)
              setCustomFieldModalOpen(true)
            }}>
              Edit
            </a>
            {" | "}
            <a href="#" onClick={(e) => {
              e.preventDefault()
              formikProps.setFieldValue(`item[custom_fields]`, currentCustomFields.filter((_, i) => i !== index))
            }}>
              Delete
            </a>
          </div>
        </div>
      )
    })
  }

  

  const renderPurchaseAndRentalInformation = (formikProps) => {
    const fieldProperties = {
      inputProps: {
        min: 0,
        step: 0.01
      },
      InputProps: {
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
        step: "0.01"
      },
      type: "number",
      step: "0.01"
    }
    return (
      <div>
        <Stack spacing={2} direction="column">
           <Stack spacing={2} direction="row">
            {isJaguar(user) && (
              <div className="w-full">
                {formikProps.values.item.for_sale ? (
                  renderMoneyField( "Sale Price", "item[sale_cost]", {key: "sale_cost",fieldProperties: {...fieldProperties, key: "sale_cost"}})
                ):(
                  renderMoneyField( "Rental Fee", "item[rental_cost]", {key: "rental_cost",fieldProperties: {...fieldProperties, key: "rental_cost"}})
                )}
              
              </div>
            )}
    
            <div className="w-full">
              {renderMoneyField( `Purchase Price ${renter ? "" : "(Internal)"}`, "item[purchase_cost]", {fieldProperties})}
            </div>

          </Stack>
          {renderTextField( `Purchase Link ${renter ? "" : "(Internal)"}`, "item[purchase_link]", "$")}
          {isJaguar(user) && (
            renderTextField( `Trax Link ${renter ? "" : "(Internal)"}`, "item[trax_link]", "$")
          )}
          {isJaguar(user) && (
            renderCheckField("Mark Item for Sale", "item[for_sale]", ['mb-0'])
          )}
        </Stack>
      </div>
    )
  }

  const generateDefaultTrackingNumberObject = () => {
    return {
      tracking_number: "",
      status: "",
      courier: "",
      temporary_id: "temp-" + Math.random()* 100000000,
      tracking_data: {},
      tracking_response: {}
    }
  }

  const renderNewItemReceivingInformation = (formikProps) => {
    const { values } = formikProps
    const { add_to_receiving_list  } = values
    if(item.draft) {
      return (
        <div className="mt-8">
          {isJaguar(user) && (
            <>
              <div className="text-black">
                Any new item that has been ordered will have to go on the Warehouse Receiving List first. Only add directly to inventory if the item is physically at the Warehouse.
              </div>
              <div className="mt-2">
                {renderRadioField("add_to_receiving_list", [
                  {label: "Add to Receiving List", value: true},
                  {label: "Add to Inventory (Warehouse Only)", value: false}
                ])}
              </div>
              {add_to_receiving_list && (
                <>
                <a href="javascript:void(0)" onClick={(e) => {
                  formikProps.setFieldValue("receiving_item_tracking_numbers", [...values.receiving_item_tracking_numbers, generateDefaultTrackingNumberObject()])
                }}>
                  + Add Tracking Number
                </a>
                {formikProps.values.receiving_item_tracking_numbers.map((tracking_number, index) => {
                  return (
                    <div className="mt-2">
                    <ReceivingListTrackingNumberForm
                      key={"tracking-number-" + tracking_number.temporary_id}
                      formikProps={formikProps}
                      index={index}
                    />
                    </div>
                  )
                })}
                <br/>
                <div className="mt-2">
                  {renderTextAreaField("Notes specific to Shipping/Receiving", "receiving_item[notes]", {})}
                </div>
                </>
              )}
            </>
          )}
          {renderCheckField("Add to Event (Optional)", "add_to_event", ['mb-0'])}
          {formikProps.values.add_to_event && (
            <ItemHoldFormRevised
              formikProps={formikProps}
              item={item}
              newItem={true}
            />
          )}
        </div>
      )
    }
  }

  const renderWarehouseInformation = (formikProps) => {
    const fieldProperties = {
      type: "number",
      InputProps: {
        endAdornment: <InputAdornment position="end">in.</InputAdornment>,
        inputProps: {
          min: 0
        }
      },
    }
    return (
      <div>
        <Stack spacing={2} direction="column">
           <Stack spacing={2} direction="row">
            {renderTextField( "Carton Width", "item[carton_width]", {fieldProperties})}
            {renderTextField( "Carton Height", "item[carton_height]", {fieldProperties})}
            {renderTextField( "Carton Depth", "item[carton_length]", {fieldProperties})}
          </Stack>
          {renderTextField( "Warehouse Location", "item[warehouse_location]", {})}
          <div>
            {renderCheckField("Audited Inventory 2025", "item[audited_2025]", ['mb-0'], {disabled: true})}
            {renderCheckField("Audited Inventory 2026", "item[audited_2026]", ['mb-0'])}
          </div>
        </Stack>
      </div>
    )
  }

  const deleteAttachment = (id) => {
    fetchAPI(`/webapi/attachments/${id}`, (json) => {
      fetchAttachments()
    }, {
      method: 'DELETE'
    })
  }

  const renderAttachments = () => {
    return attachments.map((attachment) => (
      <div className="mt-4">
        {attachment.label ? (
          <div>
            <b>Label: </b> {attachment.label}
          </div>
        ):""}
        <div>
          <b>Filename: </b> {attachment.filename}
        </div>
        <div className="text-blue-600 text-sm font-normal">
          <a download={attachment.filename} href={attachment.attachment} target="_blank">
            Download
          </a>
          {" | "}
          <a href="#" onClick={(e) => {
            e.preventDefault()
            setAttachmentModalId(attachment.id)
            setAttachmentModalOpen(true)
          }}>Edit</a>
          {" | "}
          <a href="#" onClick={(e) => {
            e.preventDefault()
            deleteAttachment(attachment.id)
          }}>
            Delete
          </a>
        </div>
      </div>
    ))
  }

  const deleteImage = (id) => {
    fetchAPI(`/webapi/images/${id}`, (json) => {
      fetchItemImages()
    }, {
      method: 'DELETE'
    })
  }

  const moveImageUp = (id) => {
    sortedItemImages = itemImages.sort((a,b) => a.order > b.order ? 1 : -1)
    const index = sortedItemImages.findIndex((image) => image.id == id)
    if(index > 0) {
      const image = sortedItemImages[index]
      sortedItemImages.splice(index, 1)
      sortedItemImages.splice(index - 1, 0, image)
      sortedItemImages = sortedItemImages.map((x,i)=>{
        x.order = i
        return x
      })
      setItemImages([...sortedItemImages])
    }
    fetchAPI(`/items/v1/item_images/order`,()=>{}, {
      method: 'PATCH',
      body: {
        ids: sortedItemImages.map(image => image.id)
      },
    })
  }

  const moveImageDown = (id) => {
    sortedItemImages = itemImages.sort((a,b) => a.order > b.order ? 1 : -1)
    const index = sortedItemImages.findIndex((image) => image.id == id)
    if(index < sortedItemImages.length - 1) {
      const image = sortedItemImages[index]
      sortedItemImages.splice(index, 1)
      sortedItemImages.splice(index + 1, 0, image)
      sortedItemImages = sortedItemImages.map((x,i)=>{
        x.order = i
        return x
      })
      setItemImages([...sortedItemImages])
    }
    fetchAPI(`/items/v1/item_images/order`,()=>{}, {
      method: 'PATCH',
      body: {
        ids: sortedItemImages.map(image => image.id)
      },
    })
  }

  const renderImages = () => {
    return itemImages.sort((a,b) => a.order > b.order ? 1 : -1).map((attachment, i) => (
      <div className="mt-4">
        {attachment.label ? (
          <div>
            <b>Label: </b> {attachment.label}
          </div>
        ):""}
        <div >
          <img style={{border:"1px solid rgb(229,229,229)"}} src={attachment.image} className="h-[200px] w-[200px] object-contain border border-neutral-200"/>
        </div>
        <div className="text-blue-600 text-sm font-normal pt-2 flex items-center mt-[-5px]">
          <div className="inline text-[#6c6c6c] pt-[5px]">
            <ArrowUpward
              style={{cursor:"pointer"}}
              onClick={(e) => {
                e.preventDefault()
                moveImageUp(attachment.id)
              }}
            />
            <ArrowDownward
              style={{cursor:"pointer"}}
              onClick={(e) => {
                e.preventDefault()
                moveImageDown(attachment.id)
              }}
            />
          </div>
          <a href="#" onClick={(e) => {
            e.preventDefault()
            setItemImageModalId(attachment.id)
            setItemImageModalOpen(true)
          }}>Replace</a>
          <div className="px-[5px]">{" | "}</div>
          <a href="#" onClick={(e) => {
            e.preventDefault()
            deleteImage(attachment.id)
          }}>
            Remove
          </a>
        </div>
      </div>
    ))
  }

  const renderForm = (formikProps) => {
    return (
      <div className="row">
          <ItemInventoryModal
            item={item}
            open={inventoryModalOpen}
            onClose={()=>{
              setInventoryModalOpen(false)
            }}
            onSave={()=>{
              setInventoryModalOpen(false)
              fetchInventoryCount()
            }}
            user={user}
            inventoryCount={inventoryCount}
            formikProps={formikProps}
          />
        <div className="col-md-8">
          <DropdownSection label="Item Inventory Details" defaultOpen>
            {renderItemDetails(formikProps)}
          </DropdownSection>
          <DropdownSection label="Item Specifications" defaultOpen>
            {renderItemSpecifications(formikProps)}
          </DropdownSection>
          <DropdownSection label={isJaguar(user) ? "Purchase and Rental Information" : "Purchase Information"} defaultOpen>
            {renderPurchaseAndRentalInformation(formikProps)}
          </DropdownSection>
          {isJaguar(user) && (
            <DropdownSection label="Internal Notes">
              <p className="text-black">
                Notes entered here are not visible to the public. Use this area to call out things such as item condition, things to make sure to order with this item etc. 
              </p>
              {renderTextAreaField( "Internal Notes", "item[internal_notes]", {
                multiline: true,
                rows: 5,
              })}
            </DropdownSection>
          )}
          {isJaguar(user) && (
            <DropdownSection onClick={
              (e) => {
                //WAit for the DOM to render
                setTimeout(() => {
                  document.getElementById("warehouseInformation").scrollIntoView( 
                    {
                      behavior: "smooth",
                      block: "start"
                    }
                  )
                }, 100)
              }
            }label="Warehouse Information">
              {renderWarehouseInformation(formikProps)}
              <div id="warehouseInformation"/>
            </DropdownSection>
          )}

          {renderNewItemReceivingInformation(formikProps)}
          <div className="hidden-xs">
            {renderButtons(formikProps)}
          </div>

        </div>
        <div className="col-md-4 hidden-xs">
          <DropdownSection label="Images" defaultOpen={true}>
            <div className="row">
              <div className="col-xs-12">
                <p className="text-black">
                Upload images here. The first image will be used as the preview image. 
                </p>
                <a href="javascript:void(0)" onClick={()=>{setItemImageModalId(null);setItemImageModalOpen(true)}}>Upload Image</a>
                <ItemImageModal
                  open={itemImageModalOpen}
                  onClose={()=>{
                    setItemImageModalId(null);
                    setItemImageModalOpen(false)
                  }}
                  formikProps={formikProps}
                  onSave={()=>{
                    setItemImageModalId(null);
                    setItemImageModalOpen(false)
                    fetchItemImages()
                  }}
                  currentImageCount={itemImages.length}
                  itemImageModalId={itemImageModalId}
                  itemImage={itemImages.find(image => image.id === itemImageModalId)}
                  user={user}
                  item={item}
                />

                {renderImages()}
              </div>
            </div>
          </DropdownSection>
          {isJaguar(user) && (
            <DropdownSection label="Attachments (Internal)" defaultOpen={true}>
              <div className="row">
                <div className="col-xs-12">
                  <p className="text-black">
                  Upload additional non-image files, such as manuals or specifications here.
                  </p>
                  <a href="javascript:void(0)" onClick={()=>{setAttachmentModalId(null);setAttachmentModalOpen(true)}}>Add Attachment</a>
                  <AttachmentModal
                    open={attachmentModalOpen}
                    onClose={()=>{
                      setAttachmentModalId(null);
                      setAttachmentModalOpen(false)
                    }}
                    formikProps={formikProps}
                    onSave={()=>{
                      setAttachmentModalId(null);
                      setAttachmentModalOpen(false)
                      fetchAttachments()
                    }}
                    attachmentModalId={attachmentModalId}
                    attachment={attachments.find(attachment => attachment.id === attachmentModalId)}
                    user={user}
                    item={item}
                  />

                  {renderAttachments()}
                </div>
              </div>
            </DropdownSection>
          )}

          {item.draft ? "" : (
            <DropdownSection label="Log" defaultOpen={true}>
              <a href="javascript:void(0)" onClick={()=>{setInventoryLogModalOpen(true)}}>View Inventory Log</a>
              <ItemLogModal
                onUpdate={()=>alert("Inventory may be out of sync until you refresh the page")}
                open={inventoryLogModalOpen}
                user={user}
                onClose={()=>setInventoryLogModalOpen(false)}
                item={item}
              />
            </DropdownSection>
          )}
        </div>
        <div className="col-xs-12 hidden-sm hidden-md hidden-lg hidden-xl">
          {renderButtons(formikProps)}
        </div>

      </div>
    )
  }

  const renderButtons = (formikProps) => {
    return (
        <div className="mb-[50px]">
          <div>
            {renderErrors(formikProps)}
          </div>
          <Stack direction="row" spacing={2} className="mt-4">
            {
              renderButton(item.draft ? "Add Item" : "Save", ()=>{
                setAttemptedSubmit(true)
                formikProps.handleSubmit()
              },{
                disabled: formikProps.isSubmitting,
                color: "green",
              })
            }
            {renderCancelButton("Cancel", ()=>{
              //Go back a page
              window.history.back()
            })}

          </Stack>
        </div>
    )
  }



  const renderErrors = (formikProps) => {
    if(!attemptedSubmit) {
      return ""
    }
    let errorsArray = formikProps.errors.item ? Object.values(formikProps.errors.item) : []
    if(formikProps.errors.quantity) {
      errorsArray.push(formikProps.errors.quantity)
    }
    return (
      <div className="text-red-600 mt-2">
        {errorsArray.map((error, index) => {
          return (
            <div key={index}>
              {error}
            </div>
          )
        })}
      </div>
    )
  }

  const validationSchema = object({
    item: object({
      name: string().required("Item Name is required"),
      category_id: string().required("Category is required"),
    }),
    quantity: item.draft ? number().required("Quantity is required") : number().nullable(),
  });
  return (
    <Formik
      initialValues={getInitialValues()}
      onSubmit={submitForm}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={true}
    >
      
      {(formikProps) => renderForm(formikProps)}
    </Formik>
  )

}

export default ItemFormRevised